export default "__VITE_ASSET__46180077__"